export { default as ColorModeScript } from './ColorModeScript'
